var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded"},[_vm._m(0),_c('PartnersCardVue')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"text text-center animate__animated animate__fadeInRight animate__slow"},[_vm._v(" Aucun Match "),_c('br'),_vm._v(" N'est Encore "),_c('br'),_vm._v(" Programmé ")])])
}]

export { render, staticRenderFns }